"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = [
    {
        payable: true,
        stateMutability: 'payable',
        type: 'fallback'
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                name: 'reason',
                type: 'uint8'
            }
        ],
        name: 'Aborted',
        type: 'event'
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                name: 'rewardPayment',
                type: 'uint256'
            },
            {
                indexed: false,
                name: 'measuredGasConsumption',
                type: 'uint256'
            }
        ],
        name: 'Cancelled',
        type: 'event'
    },
    {
        anonymous: false,
        inputs: [],
        name: 'Claimed',
        type: 'event'
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                name: 'bounty',
                type: 'uint256'
            },
            {
                indexed: false,
                name: 'fee',
                type: 'uint256'
            },
            {
                indexed: false,
                name: 'measuredGasConsumption',
                type: 'uint256'
            }
        ],
        name: 'Executed',
        type: 'event'
    },
    {
        constant: false,
        inputs: [
            {
                name: 'addressArgs',
                type: 'address[4]'
            },
            {
                name: 'uintArgs',
                type: 'uint256[12]'
            },
            {
                name: 'callData',
                type: 'bytes'
            }
        ],
        name: 'initialize',
        outputs: [],
        payable: true,
        stateMutability: 'payable',
        type: 'function'
    },
    {
        constant: false,
        inputs: [],
        name: 'execute',
        outputs: [
            {
                name: '',
                type: 'bool'
            }
        ],
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function'
    },
    {
        constant: false,
        inputs: [],
        name: 'cancel',
        outputs: [
            {
                name: '',
                type: 'bool'
            }
        ],
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function'
    },
    {
        constant: false,
        inputs: [],
        name: 'claim',
        outputs: [
            {
                name: '',
                type: 'bool'
            }
        ],
        payable: true,
        stateMutability: 'payable',
        type: 'function'
    },
    {
        constant: true,
        inputs: [],
        name: 'requestData',
        outputs: [
            {
                name: '',
                type: 'address[6]'
            },
            {
                name: '',
                type: 'bool[3]'
            },
            {
                name: '',
                type: 'uint256[15]'
            },
            {
                name: '',
                type: 'uint8[1]'
            }
        ],
        payable: false,
        stateMutability: 'view',
        type: 'function'
    },
    {
        constant: true,
        inputs: [],
        name: 'callData',
        outputs: [
            {
                name: 'data',
                type: 'bytes'
            }
        ],
        payable: false,
        stateMutability: 'view',
        type: 'function'
    },
    {
        constant: false,
        inputs: [
            {
                name: '_to',
                type: 'address'
            },
            {
                name: '_data',
                type: 'bytes'
            }
        ],
        name: 'proxy',
        outputs: [
            {
                name: 'success',
                type: 'bool'
            }
        ],
        payable: true,
        stateMutability: 'payable',
        type: 'function'
    },
    {
        constant: false,
        inputs: [],
        name: 'refundClaimDeposit',
        outputs: [
            {
                name: '',
                type: 'bool'
            }
        ],
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function'
    },
    {
        constant: false,
        inputs: [],
        name: 'sendFee',
        outputs: [
            {
                name: '',
                type: 'bool'
            }
        ],
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function'
    },
    {
        constant: false,
        inputs: [],
        name: 'sendBounty',
        outputs: [
            {
                name: '',
                type: 'bool'
            }
        ],
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function'
    },
    {
        constant: false,
        inputs: [
            {
                name: 'recipient',
                type: 'address'
            }
        ],
        name: 'sendOwnerEther',
        outputs: [
            {
                name: '',
                type: 'bool'
            }
        ],
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function'
    },
    {
        constant: false,
        inputs: [],
        name: 'sendOwnerEther',
        outputs: [
            {
                name: '',
                type: 'bool'
            }
        ],
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function'
    }
];
//# sourceMappingURL=TransactionRequestCoreABI.js.map